export const COLUMN_SEPARATOR = '___';
export const DIMENSION_SEPARATOR = '__';

export const COMPARISON_PREFIX = 'comparison';
export const PREVIOUS_PERIOD_KEY = 'previous_period';
export const TOTAL_SUFFIX = 'totals';
